/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  IdentifierTypeMethodPayment,
  MethodPaymentType
} from './payment-sale.interface';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentSaleService {
  private data = new Subject<MethodPaymentType>();
  public typesPayment = IdentifierTypeMethodPayment;

  getData() {
    return this.data.asObservable();
  }

  setData(data) {
    this.data.next(data);
  }
}
